import React from 'react';
import TextField from "../../../../Forms/TextField";
import FluentSelect from '../../../../Forms/FluentSelect';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';


const basedOnOptions = [
  { value: "Achievement Based", label: "Achievement Based" },
  { value: "Financial Need Based", label: "Need Based" },
];
const appReqOptions = [
  { value: "Essay(s)", label: "Essay(s)" },
  { value: "Recommendation(s)", label: "Recommendation(s)" },
  { value: "Transcript(s)", label: "Transcript(s)" },
  { value: "Project(s)", label: "Project(s)" },
  { value: "Videos(s)", label: "Videos(s)" },
];
const fullTuitionOptions = [
  { key: true, text: "True" },
  { key: false, text: "False" },
];
const renewableOptions = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const genderOptions = [
  { key: false, text: "No" },
  { key: true, text: "Only for women" },
];
const militaryAffiliationRequired = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const raceEthnicityOptions = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const athleticsExtracurricularsRequired = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const citizenResidentOptions = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const disabilityRequired = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];
const miscellaneousOptions = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];

const EligibilityTypeAmountFields = ({ stateOptions }) => {

  return (
    <>
      <TextField label="Award ($) Maximum" name="maxAward" required />
      <ChoiceGroup
          label={"Full Tuition"}
          options={fullTuitionOptions}
          name="fullTuition"
      />
      <TextField label="Award ($) Minimum" name="minAward" />
      <TextField label="Number of Awards" name="awardQuantity" required />
      <hr />
      <ChoiceGroup
          label="Renewable"
          options={renewableOptions}
          name="renewable"
      />
      <hr />
      <ChoiceGroup
          label="U.S. Citizenship/Permanent Residency Requirement"
          options={citizenResidentOptions}
          name="usCitizenshipRequired"
      />
      <TextField label="International Details" name="internationalDetails" />
      <FluentSelect
          options={stateOptions && stateOptions.map(s => ({ value: s.name, label: s.name }))}
          name="state"
          label='State'
          component={FluentSelect}
      />
     <TextField label="State Details" name="stateDetails" />
     <hr />
      <ChoiceGroup
          label="Gender Requirement"
          options={genderOptions}
          name="gender"
          required
      />
       <hr />
      <ChoiceGroup
          label="Race & Ethnicity Requirement"
          options={raceEthnicityOptions}
          name="minorityRequirement"
          required
      />
      <TextField label="Race & Ethnicity Requirement Details" name="minorityRequirementDetails" />
      <hr />
      <ChoiceGroup
          label="Athletics & Extracurriculars Required"
          options={athleticsExtracurricularsRequired}
          name="athleticsExtracurricularsRequired"
          required
      />
      <TextField label="Athletics & Extracurriculars Requirement Details" name="athleticsExtracurricularsDetails" />
      <hr />
      <ChoiceGroup
          label="Military Affiliation Required"
          options={militaryAffiliationRequired}
          name="militaryAffiliationRequired"
          required
      />
      <TextField label="Military Affiliation Requirement Details" name="militaryAffiliationDetails" />
      <hr />
      <ChoiceGroup
          label="Disability (of Student or Family) Required"
          options={disabilityRequired}
          name="disabilityOfStudentOrFamilyRequired"
          required
      />
      <TextField label="Disability (of Student or Family) Requirement Details" name="disabilityOfStudentOrFamilyDetails" />
      <hr />
      <ChoiceGroup
          label="Miscellaneous Requirement"
          options={miscellaneousOptions}
          name="miscellaneousRequirement"
          required
      />
      <TextField label="Miscellaneous Requirement Details" name="miscellaneousDetails" />

      <FluentSelect
          options={basedOnOptions}
          isMulti
          name="basedOn"
          label={`Achievement or Need Based (Check All That Apply)`}
          component={FluentSelect}
      />
      <FluentSelect
          options={appReqOptions}
          isMulti
          name="requirements"
          label="Application Requirements (Check All That Apply)"
          component={FluentSelect}
      />
    </>
  );
};

export default EligibilityTypeAmountFields;
